export enum TabListIdConstants {
    Recent = 'recent',
    FormsTabList = 'formsTabList'
}
